const country = {
  USA: { code: 'USA', name: 'United States' }
}

export { country }
